import MenuIcon from "@mui/icons-material/Menu";
import React, { useEffect, useRef, useState, useCallback } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./mobilenav.scss";
import Logo from "../../assets/img/logo.png";
import TopBar from "./topbar";
import NavBar from "./navbar";

const FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

const MobileNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const menuBtnRef = useRef(null);
  const closeBtnRef = useRef(null);

  const openNav = useCallback(() => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
    setTimeout(() => {
      if (closeBtnRef.current) closeBtnRef.current.focus();
    }, 50);
  }, []);

  const closeNav = useCallback(() => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
    if (menuBtnRef.current) menuBtnRef.current.focus();
  }, []);

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        closeNav();
        return;
      }
      if (e.key === "Tab" && containerRef.current) {
        const focusable = containerRef.current.querySelectorAll(FOCUSABLE);
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, closeNav]);

  useEffect(() => {
    if (isOpen && containerRef.current) {
      containerRef.current.classList.add("active");
    } else if (containerRef.current) {
      containerRef.current.classList.remove("active");
    }
  }, [isOpen]);

  return (
    <>
      <button
        className="HambergerMenuBox"
        id="MenuIcons"
        ref={menuBtnRef}
        onClick={openNav}
        aria-label="Open navigation menu"
        aria-expanded={isOpen}
        aria-controls="mobile-nav-menu"
      >
        <MenuIcon fontSize="large" aria-hidden="true" />
      </button>
      <div
        className="MobileNavContainer"
        ref={containerRef}
        id="mobile-nav-menu"
        role="dialog"
        aria-modal="true"
        aria-label="Mobile navigation"
      >
        <div className="MobileNavItemBox">
          <button
            className="CloseBTN"
            id="CloseBTNS"
            ref={closeBtnRef}
            onClick={closeNav}
            aria-label="Close navigation menu"
          >
            <CloseIcon fontSize="large" aria-hidden="true" />
          </button>
          <div className="MobileViewLogo">
            <img src={Logo} alt="Guheshwori Merchant Banking and Finance Ltd." />
          </div>
          <div className="MobileNavBox" role="navigation" aria-label="Mobile navigation menu">
            <NavBar
              closeMobileNav={() => {
                document.body.style.overflow = "auto";
                setIsOpen(false);
                if (menuBtnRef.current) menuBtnRef.current.focus();
              }}
            />
            <TopBar
              closeMobileNav={() => {
                document.body.style.overflow = "auto";
                setIsOpen(false);
                if (menuBtnRef.current) menuBtnRef.current.focus();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNav;
